import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { clx } from 'Utils';

interface Props {
	title: string;
	children: ReactNode;
	className?: string;
	contentClassName?: string;
}

export const SearchFilterGroup: FC<Props> = ({
	title,
	children,
	className,
	contentClassName
}) => {
	const { t } = useTranslation();

	return (
		<div className={clx('d-flex flex-column mb-4', className)}>
			<h5
				className="h6 lh-base text-gray-6"
				// style={{
				// 	color: '#242429'
				// }}
				>
				{t(title)}
			</h5>
			<div className={clx('flex-grow-1', contentClassName)}>
				{children}
			</div>
		</div>
	);
};

SearchFilterGroup.displayName = 'SearchFilterGroup';
